import { Urls } from "@prism/prism-shared";

export const factoryNodeDisplayHostPort = 8080;
export const factoryNodeApiPort = 8081;
export const factoryNodeWebsocketPort = 8082;

export const onsiteUtilitiesIpAddress = '42.0.0.13'
export const onsiteUtilitiesApiPort = 4700;
export const onsiteUtilitiesDomainName = "onsite-utilities";

export const dataserverIpAddress = '42.0.0.10'
export const dataserverApiPort = 4700;
export const dataserverDomainName = "primary-dataserver";

export const backupDataserverIpAddress = '42.0.0.11'
export const backupDataserverApiPort = 4700;
export const backupDataserverDomainName = "backup-dataserver"

export const factoryNode1DomainName = "factory-node-1";
export const factoryNode1IpAddress = "42.0.1.0";

// Motionmaster bridge — the Mac mini wired to the Fagor 8050 M's serial DNC port. It runs the
// FastAPI app from ~/code/motionmaster (server/app.py) on the shop LAN; onsite-utilities forwards
// the Prism client's requests to it (apps/onsite-utilities/src/api/motionmaster.api.ts).
// 42.0.8.130 is the DHCP reservation for the mini's wired port (MAC 38:c9:86:00:59:50, "motion-master-FN8").
// If the cable is out the mini falls back to wifi with a floating lease; MOTIONMASTER_MINI_HOST in
// onsite-utilities' .env overrides this constant for that case.
export const motionmasterMiniDomainName = 'prism.local';
export const motionmasterMiniIpAddress = '42.0.8.130';
export const motionmasterMiniApiPort = 8050;

// Generic compute server — the box that runs compute-intensive jobs. Nesting is the
// first tenant; future compute services get their own port on this same host.
export const computeServerDomainName = "compute-server";
export const computeServerIpAddress = '42.0.0.15';

// prism-nesting-service — an app on the compute server (host:port -> compute-server:8094).
export const nestingServiceApiPort = 8094;

/**
 * Public URL of the nesting service, served via the `seljan-compute` Cloudflare
 * Tunnel (TLS at the Cloudflare edge; the box itself is never exposed). Works from
 * EVERYWHERE — on- and off-network clients alike — so no reachability probing is
 * needed. Future compute services get their own subdomain on the same tunnel
 * (one route per service). See apps/prism-nesting-service/DEPLOYMENT.md.
 */
export const nestingServicePublicUrl = 'https://nesting.seljan-compute.com';

/**
 * Bearer token the client sends to the nesting service (must equal the server's
 * NESTING_API_TOKEN in the compute box's .env). The tunnel makes the service
 * publicly reachable, so this is REQUIRED in production — it's abuse prevention
 * (keeps strangers from burning the box's CPU), not user-level auth.
 * Empty = send nothing (matches a server with auth disabled, i.e. local dev).
 */
export const nestingServiceApiToken = 'f847cb6cc169c6c822df6cdebf1d5a3583e6386cdc5c7896f3dbcf285b976b13';



export const urlsStaging: Urls = {
    baseHostingUrl: 'https://prism-staging-d549f.web.app',
    baseDataserverUrl: `https://${onsiteUtilitiesDomainName}:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://${backupDataserverDomainName}:${backupDataserverApiPort}`,
    baseNestingServiceUrl: nestingServicePublicUrl,
}

export const urlsTesting: Urls = {
    baseHostingUrl: 'https://seljan-testing.com',
    baseDataserverUrl: `https://${onsiteUtilitiesDomainName}:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://${backupDataserverDomainName}:${backupDataserverApiPort}`,
    baseNestingServiceUrl: nestingServicePublicUrl,
}

export const urlsProduction: Urls = {
    baseHostingUrl: 'https://seljan-fishbowl.com',
    baseDataserverUrl: `https://${onsiteUtilitiesDomainName}:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://${backupDataserverDomainName}:${backupDataserverApiPort}`,
    baseNestingServiceUrl: nestingServicePublicUrl,
}

export const urlsLocalStaging: Urls = {
    baseHostingUrl: 'http://localhost:4200',
    baseDataserverUrl: `https://localhost:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://localhost:${backupDataserverApiPort}`,
    baseNestingServiceUrl: `http://localhost:${nestingServiceApiPort}`,
}

export const urlsLocalProduction: Urls = {
    baseHostingUrl: 'http://localhost:4200',
    baseDataserverUrl: `https://${onsiteUtilitiesDomainName}:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://${backupDataserverDomainName}:${backupDataserverApiPort}`,
    // local client against PRODUCTION backends (like the dataserver above) — so use the
    // deployed nesting service, not a locally-run one.
    baseNestingServiceUrl: nestingServicePublicUrl,
}

export const urlsLocalTesting: Urls = {
    baseHostingUrl: 'http://localhost:4200',
    baseDataserverUrl: `https://localhost:${onsiteUtilitiesApiPort}`,
    baseBackupDataserverUrl: `https://localhost:${backupDataserverApiPort}`,
    baseNestingServiceUrl: `http://localhost:${nestingServiceApiPort}`,
}
